import * as CryptoJS from "crypto-js";

export class CriptografiaUtil {
    static CHAVE = "@l0g!qu3-S3cr3t@";

    public static criptografar(texto: string) {
        let key  = CryptoJS.enc.Latin1.parse(this.CHAVE);
        return CryptoJS.AES.encrypt(texto, key, { iv: key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding });
    }
}


// WEBPACK FOOTER //
// ./src/util/criptografiaUtil.ts